import request from "@/util/request";

export function Course_GetList(params) {
  return request({
    url: "/pc/Course/Course_GetList",
    method: "get",
    params,
  });
}
export function Course_GetClassifys(params) {
  return request({
    url: "/pc/Course/Course_GetClassifys",
    method: "get",
    params,
  });
}
export function Course_GetTypes(params) {
  return request({
    url: "/pc/Course/Course_GetTypes",
    method: "get",
    params,
  });
}
export function Course_GetDetail(params) {
  return request({
    url: "/pc/Course/Course_GetDetail",
    method: "get",
    params,
  });
}
export function Course_GetQRCode(params) {
  return request({
    url: "/pc/Course/Course_GetQRCode",
    method: "get",
    params,
  });
}

export function Course_GetTeachers(params) {
  return request({
    url: "/pc/Course/Course_GetTeachers",
    method: "get",
    params,
  });
}
export function Course_GetRelatedCourses(params) {
  return request({
    url: "/pc/Course/Course_GetRelatedCourses",
    method: "get",
    params,
  });
}

export function Course_GetCatalogs(params) {
  return request({
    url: "/pc/Course/Course_GetCatalogs",
    method: "get",
    params,
  });
}
export function Course_GetPaper(params) {
  return request({
    url: "/pc/Course/Course_GetPaper",
    method: "get",
    params,
  });
}
export function Course_GetFileList(params) {
  return request({
    url: "/pc/Course/Course_GetFileList",
    method: "get",
    params,
  });
}
export function Course_GetFileDownUrl(params) {
  return request({
    url: "/pc/Course/Course_GetFileDownUrl",
    method: "get",
    params,
  });
}
export function Course_GetChapterFile(params) {
  return request({
    url: "/pc/Course/Course_GetChapterFile",
    method: "get",
    params,
  });
}
export function Course_StudyCount(data) {
  return request({
    url: "/pc/Course/Course_StudyCount",
    method: "post",
    data,
  });
}
export function Column_GetCourseList(params) {
  return request({
    url: "/pc/Course/Column_GetCourseList",
    method: "get",
    params,
  });
}
